module.exports = __webpack_public_path__ + "img/140.e03d3415.jpg";